module.exports = __webpack_public_path__ + "static/media/mtbank-small.93d5cd25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mtbank-small.png
// module id = 523
// module chunks = 0